import {
    GET_RESE_LEAK_MONITORING_TABLE_DATA,
    GET_RESE_LEAK_MONITORING_MATERIAL_TYPE,
    GET_RESE_LEAK_MONITORING_MATERIAL_DURATION,
    POST_RESE_LEAK_MONITORING_INFORMATION,
    RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS,
} from "./actionTypes";

export const getReseLeakMonitoringTableDataInit = (startDatetime, endDatetime, offset) => ({
    type: GET_RESE_LEAK_MONITORING_TABLE_DATA.INIT,
    startDatetime, endDatetime, offset
});

export const getReseLeakMonitoringTableDataSuccess = (tableData) => ({
    type: GET_RESE_LEAK_MONITORING_TABLE_DATA.SUCCESS,
    payload: tableData
});

export const getReseLeakMonitoringTableDataError = (error) => ({
    type: GET_RESE_LEAK_MONITORING_TABLE_DATA.ERROR,
    payload: error
});

export const getReseLeakMonitoringMaterialTypeInit = (columnPayload) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_TYPE.INIT,
    columnPayload
});

export const getReseLeakMonitoringMaterialTypeSuccess = (materialTypes) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_TYPE.SUCCESS,
    payload: materialTypes
});

export const getReseLeakMonitoringMaterialTypeError = (error) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_TYPE.ERROR,
    payload: error
});

export const getReseLeakMonitoringMaterialDurationInit = (columnPayload) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_DURATION.INIT,
    columnPayload
});

export const getReseLeakMonitoringMaterialDurationSuccess = (materialDurations) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_DURATION.SUCCESS,
    payload: materialDurations
});

export const getReseLeakMonitoringMaterialDurationError = (error) => ({
    type: GET_RESE_LEAK_MONITORING_MATERIAL_DURATION.ERROR,
    payload: error
});

export const postReseLeakMonitoringInformationInit = (monitoringInfo) => ({
    type: POST_RESE_LEAK_MONITORING_INFORMATION.INIT,
    monitoringInfo
});

export const postReseLeakMonitoringInformationSuccess = (successMessage) => ({
    type: POST_RESE_LEAK_MONITORING_INFORMATION.SUCCESS,
    payload: successMessage
});

export const postReseLeakMonitoringInformationError = (error) => ({
    type: POST_RESE_LEAK_MONITORING_INFORMATION.ERROR,
    payload: error
});

export const resetReseLeakMonitoringSubmitStatus = () => ({
    type: RESET_RESE_LEAK_MONITORING_SUBMIT_STATUS
});
